<template>
  <v-fade-transition>
    <div class="pt-8 color--nice-black">
      <section>
        <p class="font--m-6 font-weight-bold">미래 매출로 천천히 나누어 결제하세요</p>
        <h1 class="font--m-1 mb-2">외상결제</h1>
        <p class="font--m-5">
          사업자에게 꼭 필요한 국내 최고의 공급사들과 제휴하여 최저가 & 외상으로 이용하실 수
          있습니다.
        </p>
      </section>

      <section class="full background--accent white--text">
        <div class="px py-3">
          <p class="font--m-6">외상 가능</p>
          <h1 class="font--m-1">2,900,000원</h1>
          <p class="font--m-7">현재 이용중인 외상 1,100,000원 / 총 한도 4,000,000원</p>
        </div>
      </section>

      <section>
        <!-- <h1 class="font--m-1 mb-2">내 거래 공급사</h1>
        <v-layout justify-space-between align-center class="wholesaler-item">
          <span class="font--m-4 pr-2">판다미트</span>
          <v-btn
            height="44"
            large
            depressed
            outlined
            class="rounded-5 font-weight-bold"
            :to="{
              name: 'credit-pay/requests/form',
              query: { wholesaler: '3702110b-9fe1-49a4-9591-31fde915db86' },
            }"
          >
            외상결제
          </v-btn>
        </v-layout>
        <v-layout justify-space-between align-center>
          <span class="font--m-4 pr-2">바로육가공</span>
          <v-btn height="44" large depressed outlined class="rounded-5 font-weight-bold">
            외상결제
          </v-btn>
        </v-layout> -->

        <v-btn
          height="52"
          color="accent"
          class="mt-6 rounded-5 font--m-3"
          block
          large
          outlined
          depressed
          :to="{ name: 'credit-pay/requests' }"
        >
          거래내역
        </v-btn>

        <v-btn
          height="52"
          color="accent"
          class="mt-4 rounded-5 font--m-3"
          block
          large
          depressed
          :to="{ name: 'credit-pay/requests/form' }"
        >
          외상결제 신청하기
        </v-btn>
      </section>

      <div class="divide-block"></div>

      <section class="pt-5">
        <h1 class="font--m-1 mb-2">외상마켓 공식 제휴몰</h1>

        <v-layout
          v-for="(wholesaler, index) in publicWholesalers"
          :key="index"
          class="public-wholesaler--item"
        >
          <v-col cols="5" class="d-flex align-center">
            <v-img :src="wholesaler.logo" />
          </v-col>
          <v-col cols="7" class="">
            <h5>{{ wholesaler.title }}</h5>
            <h3>{{ wholesaler.name }}</h3>
            <p v-html="wholesaler.description" class="mt-2 font--m-5"></p>
          </v-col>
        </v-layout>
      </section>
    </div>
  </v-fade-transition>
</template>

<script>
export default {
  data() {
    return {
      publicWholesalers: [
        {
          title: '식자재 구매',
          name: '식봄',
          description: '요식업에 필요한 20만 종의 식자재를 국내 최저가로 쇼핑하세요!',
          logo: require('@/assets/images/credit-pay/wholesaler/logo/sikbom.png'),
        },
        {
          title: '블로그마케팅',
          name: '레뷰',
          description: '업종별 1:1 맞춤 상담 무료<br/ >인플루언서 88만명!',
          logo: require('@/assets/images/credit-pay/wholesaler/logo/revu.png'),
        },
        {
          title: '세무회계',
          name: '세친구',
          description: '국내 최고의 세무회계 법인<br />매출관리 및 세금관리, 세금신고',
          logo: require('@/assets/images/credit-pay/wholesaler/logo/3friend.png'),
        },
        {
          title: '1등 고기 직거래',
          name: '미트박스',
          description: '율류 4500+식재료 200개!<br />미트박스와 30% 원가절감하세요!',
          logo: require('@/assets/images/credit-pay/wholesaler/logo/meatbox.png'),
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}
section:not(:last-of-type) {
  margin-bottom: 30px;
}
section:not(.full),
.px {
  padding: 0 12px;
}
.wholesaler-item:not(:last-of-type) {
  margin-bottom: 8px;
}
.public-wholesaler--item {
  min-height: 130px;
}
.public-wholesaler--item:not(:last-of-type) {
  margin-bottom: 8px;
  border-bottom: 1px solid #e1e9f3;
}
</style>
